"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return MapViewColumn;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _extractProps = require("~/helpers/extractProps");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MapViewColumn = class MapViewColumn {
    static async get(context, mapViewColumnId, ncMeta = _Noco.default.ncMeta) {
        let viewColumn = mapViewColumnId && await _NocoCache.default.get(context, `${_globals.CacheScope.MAP_VIEW_COLUMN}:${mapViewColumnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!viewColumn) {
            viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW_COLUMNS, mapViewColumnId);
            if (viewColumn) {
                await _NocoCache.default.set(context, `${_globals.CacheScope.MAP_VIEW_COLUMN}:${mapViewColumnId}`, viewColumn);
            }
        }
        return viewColumn && new MapViewColumn(viewColumn);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        const insertObj = {
            fk_view_id: column.fk_view_id,
            fk_column_id: column.fk_column_id,
            order: await ncMeta.metaGetNextOrder(_globals.MetaTable.MAP_VIEW_COLUMNS, {
                fk_view_id: column.fk_view_id
            }),
            show: column.show,
            base_id: column.base_id,
            source_id: column.source_id
        };
        if (!insertObj.source_id) {
            const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
            insertObj.source_id = viewRef.source_id;
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW_COLUMNS, insertObj);
        return this.get(context, id, ncMeta).then(async (viewCol)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.MAP_VIEW_COLUMN, [
                column.fk_view_id
            ], `${_globals.CacheScope.MAP_VIEW_COLUMN}:${id}`);
            return viewCol;
        });
    }
    static async list(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.MAP_VIEW_COLUMN, [
            viewId
        ]);
        let { list: views } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !views.length) {
            views = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW_COLUMNS, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.MAP_VIEW_COLUMN, [
                viewId
            ], views);
        }
        views.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return views == null ? void 0 : views.map((v)=>new MapViewColumn(v));
    }
    // todo: update prop names
    static async update(context, columnId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'order',
            'show',
            'width',
            'group_by',
            'group_by_order',
            'group_by_sort'
        ]);
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW_COLUMNS, updateObj, columnId);
        // get existing cache
        const key = `${_globals.CacheScope.MAP_VIEW_COLUMN}:${columnId}`;
        await _NocoCache.default.update(context, key, updateObj);
        // on view column update, delete any optimised single query cache
        {
            const viewCol = await this.get(context, columnId, ncMeta);
            const view = await _View.default.get(context, viewCol.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ]);
        }
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
